import { Typography } from '@memoresa/ui-components';
import clsx from 'clsx';
interface IProductActionsButton
  extends React.DetailedHTMLProps<
      React.ButtonHTMLAttributes<HTMLButtonElement>,
      HTMLButtonElement
    >,
    React.AriaAttributes {
  variant?: 'primary' | 'secondary';
}

export const ProductActionsButton: React.FC<IProductActionsButton> = props => {
  const variant = props.variant ?? 'primary';
  const { className, ...rest } = props;
  return (
    <button
      className={clsx(
        'focus-visible:outline-none rounded-md relative flex items-center justify-center w-full h-10 sm:h-[54px] focus-visible:outline-2 focus-visible:outline-secondary focus-visible:outline-offset-2 ',
        variant === 'primary' &&
          'bg-secondary text-secondary-contrast hover:bg-secondary-light active:bg-secondary-dark disabled:bg-[#CACACA] disabled:text-[#7D7D7D]',
        variant === 'secondary' &&
          'bg-secondary-contrast disabled:bg-secondary-contrast text-secondary ring-1 ring-secondary hover:bg-secondary-opacity-10 active:bg-secondary-opacity-20 disabled:ring-[#7D7D7D] disabled:text-[#7D7D7D]',
        className
      )}
      {...rest}
    >
      <Typography className="font-semibold text-[16px] sm:text-[16px] uppercase">
        {rest.children}
      </Typography>
    </button>
  );
};
